import i18n from '@/i18n';

const PROFILE_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};

export function formatProfileDate(isoDate: string): string {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    throw new Error(`Invalid profile createdAt: ${isoDate}`);
  }
  return new Intl.DateTimeFormat(i18n.language, PROFILE_DATE_FORMAT).format(date);
}
